import React from "react";
import "./App.css";
import HomeScreen from "./screens/HomeScreen";
import {Route, Routes } from "react-router-dom";
import LoginScreen from "./screens/LoginScreen";
import ProfileScreen from "./screens/ProfileScreen";
import SignupScreen from "./screens/SignupScreen";
import RegisterScreen from "./screens/RegisterScreen";
import VideoScreen from "./screens/VideoScreen";

function App() {


  return (
    <div className="app">
      <Routes>
        <Route path="/" element={<LoginScreen />}>
        </Route>
        <Route path="/signin" element={<SignupScreen />}>
        </Route>
        <Route path="/signup" element={<RegisterScreen />}>
        </Route>
        <Route path="/home" element={<HomeScreen />}>
        </Route>
        <Route path='/video/:id' element={<VideoScreen></VideoScreen>}></Route>

        <Route path="/profile" element={<ProfileScreen />}>
        </Route>
      </Routes>
    </div>
  );
}

export default App;
